/**
 * @description 批改-變更項目
 */
export enum EndorseType {
    /** 變更聯絡地址 */
    CONTACT_ADDRESS = 'CONTACT_ADDRESS',
    /** 變更聯絡電話 */
    CONTACT_MOBILE = 'CONTACT_MOBILE',
    /** 變更電子郵件信箱 */
    CONTACT_EMAIL = 'CONTACT_EMAIL',
    /** 變更婚姻狀況 */
    MARRIAGE_STATUS = 'MARRIAGE_STATUS',
    /** 補發強制險保險證 */
    RE_SEND_COMPULSORY = 'RE_SEND_COMPULSORY',
    /** 變更名字 */
    NAME = 'NAME',
    /** 變更引擎號碼 */
    ENGINE_ID = 'ENGINE_ID',
    /** 變更車身號碼 */
    VEHICLE_ID='VEHICLE_ID',
    /** 重領牌而變更車號 */
    CAR_LICENSE = 'CAR_LICENSE',
    /** 變更發照年月 */
    ISSUE_DATE = 'ISSUE_DATE',
    /** 變更航班資訊 */
    FLIGHT_INFORMATION = 'FLIGHT_INFORMATION',
    /** 增加抵押權人 */
    ADD_MORTGAGE = 'ADD_MORTGAGE',
    /** 標的物門牌整編 */
    HOUSE_NUMBER = 'HOUSE_NUMBER'
}
